import React from "react";
import { Link } from "react-router-dom";
import { DEFAULT_PRODUCT_IMAGE } from "../../utils/productPresentation";

const formatBlogDate = (value) => {
  if (!value) {
    return "Recently published";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "Recently published";
  }

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
};

const getBlogSubCategory = (blog) => {
  const value =
    blog?.sub_category ??
    blog?.sub_category_name ??
    blog?.subCategory ??
    blog?.subcategory ??
    "";

  if (value && typeof value === "object") {
    return String(value.name || value.label || "").trim();
  }

  return String(value || "").trim();
};

function BlogCard({ blog }) {
  if (!blog) {
    return null;
  }

  const subCategory = getBlogSubCategory(blog);

  return (
    <article className="blogs-card">
      <div className="blogs-card__image-wrap">
        <img
          src={blog.image_url || DEFAULT_PRODUCT_IMAGE}
          alt={blog.title || "Blog"}
          className="blogs-card__image"
          loading="lazy"
          onError={(event) => {
            event.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
          }}
        />
        {blog.category || subCategory ? (
          <span className="blogs-card__category">
            {blog.category || ""}
            {blog.category && subCategory ? " • " : ""}
            {subCategory}
          </span>
        ) : null}
      </div>

      <div className="blogs-card__body">
        <div className="blogs-card__meta">
          <span>{formatBlogDate(blog.published_at)}</span>
          {blog.read_time ? <span>{blog.read_time}</span> : null}
        </div>

        <h3 className="blogs-card__title">{blog.title}</h3>

        <p className="blogs-card__excerpt line-clamp-2-custom">
          {blog.short_description ||
            "Helpful guidance and practical insights from Elumia Med Store."}
        </p>

        <div className="blogs-card__footer">
          <span className="blogs-card__author">
            {blog.author_name || "Elumia Med Store"}
          </span>
          {blog.slug ? (
            <Link className="blogs-card__read-more" to={`/blogs/${blog.slug}`}>
              Read More
            </Link>
          ) : null}
        </div>
      </div>
    </article>
  );
}

export default BlogCard;
